import { v4 as uuidv4 } from 'uuid';
import {
  Criterion,
  CriterionBehavior,
  CriterionListItem,
  FieldChoice,
  ListValueType,
  SelectionBehavior,
} from 'queries';
import { ICriterionHandler } from './ICriterionHandler';
import { ParticipantField, ParticipantFieldType } from '@app/api';

export class TextCriterionHandler extends ICriterionHandler {
  handleCriterion(criterion: Criterion) {
    return criterion.listValueType === ListValueType.TEXT;
  }

  criterionHandleOthers() {
    return true;
  }

  handleParticipantField(field: ParticipantField): boolean {
    return field.type === ParticipantFieldType.SHORT_TEXT;
  }

  createEmptyCriterionFromParticipantField(field: ParticipantField): Criterion {
    return {
      id: uuidv4(),
      fieldRef: field.name,
      screenerCriterion: false,
      selectionBehavior: SelectionBehavior.NO_SELECTION,
      listValueType: ListValueType.TEXT,
      denyList: [],
    };
  }

  setCriterionValues(
    criterion: Criterion,
    values?: CriterionListItem[],
    choices?: FieldChoice[],
  ): Criterion {
    if (!values) {
      return {
        ...criterion,
        allowList: null,
        denyList: [],
      };
    }

    const res = { ...criterion };

    res.allowList = values.map(String);
    res.denyList = [];

    return res;
  }
}
